<template>
  <div
    v-if="oidcIsAuthenticated"
  >
  <div class="input_container change-name">
  <table style="text-align: center;">
      <tr>
        <th>Current Last Name: </th>
        <td class= "content" v-html="Last"></td>
      </tr>
    </table>
    <div id='EP'>
    <input v-model="newLastName" type="text" placeholder="New Last Name" /><br>
    <button v-on:click="executeLastName">Change Last Name</button><br>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CognitoIDSP from 'aws-sdk/clients/cognitoidentityserviceprovider'

var cognito = new CognitoIDSP({
  region: 'eu-west-2'
})

export default {
  name: 'ChangeLastName',
  data: function () {
    return {
      newLastName: ''
    }
  },
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcAccessToken',
      'oidcUser'
    ]),
    Last: function () {
      return this.oidcUser['family_name']
    }
  },
  methods: {
    executeLastName: function () {
      var changeLastNameParam = {
        AccessToken: this.oidcAccessToken,
        UserAttributes:
        [
          {
            Name: 'family_name',
            Value: this.newLastName
          }
        ]
      }
      cognito.updateUserAttributes(changeLastNameParam, function (err, data) {
        if (err) {
          alert('Your last name could not be changed. Please try again later.')
        } else {
          alert('Your last name has been changed. Please re-login to see the change.')
        }
      })
    }
  }
}
</script>
<style>
</style>
